import { Observable } from 'rxjs';

import { ModuleDocumentOutput } from 'module/model/module-document.output';
import { ModuleOutput } from 'module/model/module.output';
import { ModuleGraphOutput } from 'module/model/page/graph/module-graph.output';

import { CreateModuleCmd } from '../command/create-module.cmd';
import { FetchModulesQuery } from '../query/fetch-modules.query';

export abstract class ModuleApiPort {
	public abstract fetchModuleById(id: string): Promise<ModuleOutput>;

	public abstract firstCoachingPlanModule(): Observable<ModuleOutput>;

	public abstract fetchModules(
		query: FetchModulesQuery
	): Promise<ModuleOutput[]>;

	public abstract fetchModulesByIds(
		modulesId: string[]
	): Promise<ModuleOutput[]>;

	public abstract generateModuleDocumentUrl(
		file: File
	): Observable<ModuleDocumentOutput>;

	public abstract createModule(cmd: CreateModuleCmd): Promise<string>;

	public abstract fetchModuleGraphsByIds(
		ids: string[]
	): Promise<ModuleGraphOutput[]>;
}
